/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React, { useContext, useEffect, useState } from 'react';
import { Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import RightSlider from '../../components/Common/RightSlider/RightSlider';
import Card from './Components/Card';
import './styles.css';
import { LanguageContext } from '../../libs/Context';
import { getContactLS } from '../actions/license_subscription';
import Loading from '../../components/Common/Loaders/FullWidthLoader/Loading';
const LicenseSubscriptions = (props) =>
{
	const { language } = useContext(LanguageContext);
	const { setOpenPlanSlider } = props;
	const [ contactDetails, setContactDetails ] = useState<any>({});
	const [ loading, setLoading ] = useState<boolean>(true);

	// Make Contact API Call
	const getContactDetails = async () =>
	{
		setLoading(true);
		try
		{
			const res = await getContactLS();

			if (res.status)
			{
				setContactDetails(res?.data);
				setLoading(false);
			}
		}
		catch (err)
		{
			console.log(err);
			setLoading(false);
		}
	};

	useEffect(() =>
	{
		getContactDetails();
	}, []);

	const handleClose = () =>
	{
		setOpenPlanSlider(false);
	};

	return (

		<div className='flexMinHeightCol scrollY' >

			<div className='flexRow fxdRSliderHdr alignCntr pdngSM '>
				<div className='flexMinWidthRow'>
					<span className='mainHdngTxt pdngHXS'>{language?.yourplanexpired}</span>
				</div>
				<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleClose(); }} className='flexAutoRow pointer' onClick={handleClose} >
					<Tooltip title={language?.close}>
						<CloseIcon />
					</Tooltip>
				</button>
			</div>
			<div className='flexMinHeightCol scrollY'>

				<RightSlider title={language?.licenseinstruct}>
					<Card handleClose={handleClose}/>
				</RightSlider>

				{/* when i click bussiness prospective contact detail show only other should hide */}
				<div className='flexCol alignCntr justifyCntr pdngXS'>
					<span className='pdngXS'>{language?.or}</span>
					<span className='pdngXS subHeadingSM'>{language?.contactadsales}</span>
					{ (contactDetails?.admin?.phone || contactDetails?.admin?.email || contactDetails?.sales?.phone || contactDetails?.sales?.email)
						? (
							<>
								{loading && <Loading />}
								<div className='flexAutoRow justifyCntr lightTxt'>
									<span className='flexAutoRow pdngXS'>{language?.admin}:</span>
									<span className='flexMinWidthRow pdngXS'>{contactDetails?.admin?.phone ? contactDetails?.admin?.phone : 'N/A'}, {contactDetails?.admin?.email ? contactDetails?.admin?.email : 'N/A'}</span>
								</div><div className='flexAutoRow justifyCntr lightTxt'>
									<span className='flexAutoRow pdngXS'>{language?.sales}:</span>
									<span className='flexMinWidthRow pdngXS'>{contactDetails?.sales?.phone ? contactDetails?.sales?.phone : 'N/A'}, {contactDetails?.sales?.email ? contactDetails?.sales?.email : 'N/A'}</span>
								</div>
							</>
						)
						: (
							<p> {language?.contactDetailsNA} </p>
						)
					}
				</div>
			</div>
		</div>

	);
};

export default LicenseSubscriptions;